import { Component, StrictMode, type ErrorInfo, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { WebShell } from './web-shell';
import './styles.css';
import './site-navigation.css';

const root = document.getElementById('root');
if (!root) throw new Error('Web root element is missing');

class WebErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Web page rendering failed', error, info.componentStack);
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return <main className="fatal-page">
      <img src="/redd-market-hero-v2.png" alt="REDD 饰品陈列"/>
      <section>
        <span>PAGE RECOVERY</span>
        <h1>页面刚刚遇到了一点问题</h1>
        <p>账户和订单数据不会受到影响。您可以重新载入当前页面，或先返回首页继续浏览。</p>
        <div><button onClick={() => window.location.reload()}>重新载入</button><a href="#/">返回首页</a></div>
      </section>
    </main>;
  }
}

createRoot(root).render(
  <StrictMode>
    <WebErrorBoundary><WebShell /></WebErrorBoundary>
  </StrictMode>,
);
